import { Component, OnInit, Output, EventEmitter, inject } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { filter, Observable } from "rxjs";

import {
    ConsultationService,
    SearchResult,
} from "../services/consultation.service";
import { ZASConstants, DataReadable } from "../data/model.constants";
import { createConsultationProcess } from "../data/model-utils";
import { PersistenceService } from "../store/model/persistence.service";
import { RootState } from "../store/root";
import { SearchState } from "../store/search/state";
import { SearchHint } from "../data/model";
import * as Actions from "../store/search/actions";
import { LoggerService } from "../services/logger.service";

@Component({
    selector: "zbd-search-form",
    templateUrl: "search-form.component.html",
})
export class SearchFormComponent implements OnInit {
    @Output() onSearchResultsUpdate: EventEmitter<SearchResultsUpdate> =
        new EventEmitter<SearchResultsUpdate>();
    @Output() onSearchFailed: EventEmitter<any> = new EventEmitter<any>();
    @Output() onCreateFailed: EventEmitter<any> = new EventEmitter<any>();

    state$: Observable<SearchState>;
    searching = false;

    isCreatingProcess = false;
    countryList: DataReadable[];
    consultationOccasionList: DataReadable[];
    tempHint: SearchHint;

    private logger = inject(LoggerService);

    constructor(
        private consultationService: ConsultationService,
        private persistence: PersistenceService,
        private router: Router,
        private store: Store<RootState>,
    ) {
        this.state$ = store
            .select<SearchState>((s) => s.search)
            .pipe(filter((x) => x !== undefined));
    }

    ngOnInit(): void {
        this.countryList = ZASConstants.asList(ZASConstants.CountryTable);
        this.consultationOccasionList = ZASConstants.asList(
            ZASConstants.ConsultationOccasionTable,
        );
        /*this.consultationService.consultationProcess$.subscribe(cp => {
            this.onSearchResultsUpdate.emit([cp])
        })*/
    }

    public search(page?: number): void {
        this.searching = true;
        this.consultationService
            .searchProcesses(this.tempHint, page ? page : 0)
            .subscribe(
                (searchResults) => {
                    this.searching = false;
                    this.onSearchResultsUpdate.emit({
                        results: searchResults,
                        page: page,
                    });
                },
                (error) => {
                    this.searching = false;
                    this.onSearchFailed.emit(error);
                },
            );
    }

    onSearchFormSubmit(hint: SearchHint): void {
        this.onSearchResultsUpdate.emit({
            results: undefined,
            page: undefined,
        });
        this.tempHint = hint;
        this.search();
    }

    onNewProcessClick(): void {
        this.isCreatingProcess = true;
        const cp = createConsultationProcess();
        this.persistence.mergeConsultationProcess(null, cp).subscribe(
            (result) => {
                this.isCreatingProcess = false;
                if (!result.Success) {
                    this.logger.error(
                        "Failed to create a CP: %s",
                        result.Reason,
                    );
                    return;
                }
                this.logger.log("Created a CP with ID: %d", result.ProcessId);
                this.router.navigate([result.ProcessId]);
            },
            (error) => {
                this.isCreatingProcess = false;
                this.onCreateFailed.emit(error);
            },
        );
    }

    reset(): void {
        this.store.dispatch(new Actions.Reset());
        this.onSearchResultsUpdate.emit({
            results: undefined,
            page: undefined,
        });
    }

    updateHint = (
        _entity: any,
        property: string,
        value: any,
        _flush: boolean,
    ): void => {
        this.store.dispatch(new Actions.Update(property as any, value));
    };

    setExtended = (
        _entity: any,
        _property: string,
        value: any,
        _flush: boolean,
    ): void => {
        this.store.dispatch(new Actions.SetExtended(value));
    };
}

export class SearchResultsUpdate {
    results: SearchResult[];
    page: number;
}
